var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"subject-tip",style:(_vm.setStyle())},[_vm._v(_vm._s(_vm.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }